import React from 'react';

const SECTION = "max-w-4xl mx-auto px-6 py-12 print:py-8";

const Apresentacao = () => {
  const handlePrint = () => window.print();

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="apresentacao-page">
      {/* Botao Imprimir/PDF (some no print) */}
      <div className="fixed top-4 right-4 print:hidden z-50">
        <button
          onClick={handlePrint}
          className="bg-[#0A2647] hover:bg-[#0e3260] text-[#C5A059] font-bold px-5 py-3 rounded-xl shadow-lg text-sm"
          data-testid="print-pdf-btn"
        >
          Salvar como PDF / Imprimir
        </button>
      </div>

      {/* CAPA */}
      <div className="w-full bg-gradient-to-br from-[#0A2647] to-[#000814] text-white">
        <section className={`${SECTION} min-h-screen flex flex-col justify-center items-center text-center print:min-h-fit`}>
          <div className="bg-[#C5A059] text-[#0A2647] font-bold px-4 py-1.5 rounded-full text-xs tracking-widest mb-8">
            APRESENTACAO EXECUTIVA
          </div>
          <h1 className="text-5xl md:text-7xl font-black mb-4 text-[#C5A059]">
            FALO COM O DONO<span className="text-2xl align-top">™</span>
          </h1>
          <p className="text-xl md:text-2xl max-w-2xl text-white/85 mb-4">
            Voce fala, a gente faz acontecer.
          </p>
          <p className="text-base md:text-lg text-white/65 max-w-2xl mt-12 italic">
            Capture a manifestacao espontanea do seu cliente.<br />
            Resolva problemas antes que virem reclamacoes publicas.<br />
            Multiplique avaliacoes positivas no Google.
          </p>
        </section>
      </div>

      {/* O PROBLEMA */}
      <section className={SECTION}>
        <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">O PROBLEMA</p>
        <h2 className="text-3xl md:text-4xl font-black text-[#0A2647] mb-6 leading-tight">
          91% dos seus clientes insatisfeitos<br />nao reclamam — apenas nao voltam.
        </h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          Fonte: <strong>National Restaurant Association</strong> (relatorio anual 2024).
        </p>
        <p className="text-base text-slate-700 leading-relaxed">
          Esse silencio custa caro: cada cliente perdido representa, segundo a <strong>Harvard Business Review</strong>,
          de 3 a 5 vezes o valor da primeira compra ao longo da vida util (LTV).
        </p>
      </section>

      {/* A SOLUCAO */}
      <div className="w-full bg-slate-50 print:bg-white">
        <section className={SECTION}>
          <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">A SOLUCAO</p>
          <h2 className="text-3xl md:text-4xl font-black text-[#0A2647] mb-8 leading-tight">
            Um canal direto entre cliente e dono.<br />Anonimo, sem fricao, em tempo real.
          </h2>

          <div className="grid md:grid-cols-3 gap-5">
            {[
              { num: '1', title: 'Cliente avalia em 30s', desc: 'QR Code na mesa ou no balcao. Sem app, sem cadastro.' },
              { num: '2', title: 'Dono recebe na hora', desc: 'WhatsApp e e-mail com a manifestacao detalhada por criterio.' },
              { num: '3', title: 'Voce age antes da crise', desc: 'Resolve com o cliente antes que ele poste no Google.' },
            ].map((s) => (
              <div key={s.num} className="bg-white rounded-2xl p-6 border border-slate-200">
                <p className="text-3xl font-black text-[#C5A059] mb-3">{s.num}</p>
                <h3 className="text-lg font-bold text-[#0A2647] mb-2">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* DIFERENCIAL */}
      <section className={SECTION}>
        <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">O DIFERENCIAL</p>
        <h2 className="text-3xl md:text-4xl font-black text-[#0A2647] mb-8 leading-tight">
          Direciona automaticamente para o canal certo.
        </h2>

        <div className="grid md:grid-cols-2 gap-5">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded-r-2xl p-6">
            <p className="text-xs font-bold text-emerald-700 mb-2 tracking-widest">CLIENTE SATISFEITO (4-5 ⭐)</p>
            <h3 className="text-xl font-bold text-emerald-900 mb-2">→ Convidado ao Google Maps</h3>
            <p className="text-sm text-emerald-800 leading-relaxed">
              A avaliacao positiva vira <strong>divulgacao publica</strong> no Google,
              fortalecendo a reputacao do negocio.
            </p>
          </div>
          <div className="bg-red-50 border-l-4 border-red-500 rounded-r-2xl p-6">
            <p className="text-xs font-bold text-red-700 mb-2 tracking-widest">CLIENTE INSATISFEITO (1-3 ⭐)</p>
            <h3 className="text-xl font-bold text-red-900 mb-2">→ Reclamacao detalhada e privada</h3>
            <p className="text-sm text-red-800 leading-relaxed">
              Captura tags especificas (Atendimento, Produto, Ambiente) para o dono
              <strong> resolver internamente</strong> antes que vire publica.
            </p>
          </div>
        </div>
      </section>

      {/* TAXA DE RECOMENDACAO */}
      <div className="w-full bg-[#0A2647] text-white print:bg-white print:text-slate-900">
        <section className={SECTION}>
          <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">METRICA EXCLUSIVA</p>
          <h2 className="text-3xl md:text-4xl font-black mb-8 leading-tight">
            Taxa de Recomendacao Publica<span className="text-[#C5A059]">.</span>
          </h2>
          <p className="text-base text-white/80 print:text-slate-700 leading-relaxed mb-6 max-w-3xl">
            Diferente do NPS classico (que pesquisa o cliente passivo), nossa metrica
            mede a <strong>manifestacao espontanea</strong> daqueles que QUISERAM falar.
            O resultado mostra qual percentual dos clientes engajados vira recomendacao
            publica no Google.
          </p>

          <div className="grid md:grid-cols-3 gap-4 mt-10">
            <div className="bg-emerald-500/15 border border-emerald-400/40 rounded-xl p-5 print:bg-emerald-50 print:border-emerald-300">
              <p className="text-3xl font-black text-emerald-300 print:text-emerald-700 mb-1">80%+</p>
              <p className="text-xs font-bold text-emerald-200 print:text-emerald-700 tracking-widest mb-2">EXCELENTE</p>
              <p className="text-sm text-white/75 print:text-slate-700">Reputacao saudavel, mais avaliacoes 5⭐ chegando ao Google.</p>
            </div>
            <div className="bg-amber-500/15 border border-amber-400/40 rounded-xl p-5 print:bg-amber-50 print:border-amber-300">
              <p className="text-3xl font-black text-amber-300 print:text-amber-700 mb-1">60-79%</p>
              <p className="text-xs font-bold text-amber-200 print:text-amber-700 tracking-widest mb-2">SAUDAVEL</p>
              <p className="text-sm text-white/75 print:text-slate-700">Ha espaco para acao em criterios especificos.</p>
            </div>
            <div className="bg-red-500/15 border border-red-400/40 rounded-xl p-5 print:bg-red-50 print:border-red-300">
              <p className="text-3xl font-black text-red-300 print:text-red-700 mb-1">&lt;60%</p>
              <p className="text-xs font-bold text-red-200 print:text-red-700 tracking-widest mb-2">ATENCAO</p>
              <p className="text-sm text-white/75 print:text-slate-700">Sinal de alerta para revisao operacional urgente.</p>
            </div>
          </div>
        </section>
      </div>

      {/* RELATORIO SEMANAL */}
      <section className={SECTION}>
        <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">PARA O GESTOR DE EXPERIENCIA</p>
        <h2 className="text-3xl md:text-4xl font-black text-[#0A2647] mb-6 leading-tight">
          Relatorio semanal automatico,<br />direto pro responsavel certo.
        </h2>
        <p className="text-base text-slate-600 leading-relaxed mb-6 max-w-3xl">
          Toda sexta-feira as 17h, o sistema dispara automaticamente o relatorio consolidado
          por e-mail e WhatsApp para todos os destinatarios cadastrados — dono, responsavel
          pelo atendimento, gerente de operacoes.
        </p>

        <div className="bg-slate-100 rounded-2xl p-6 border border-slate-200">
          <p className="text-sm font-bold text-[#0A2647] mb-3">O QUE VEM NO RELATORIO:</p>
          <ul className="space-y-2 text-sm text-slate-700">
            <li>✅ Total de manifestacoes da semana e nota media</li>
            <li>✅ <strong>Taxa de Recomendacao Publica</strong> (% que foi pro Google)</li>
            <li>✅ Notas por criterio: Produtos / Atendimento / Ambiente</li>
            <li>✅ Melhor avaliacao da semana (texto integral)</li>
            <li>✅ Avaliacao critica que precisa de atencao</li>
            <li>✅ Link direto para o Dashboard completo</li>
          </ul>
        </div>
      </section>

      {/* PLANOS */}
      <div className="w-full bg-slate-50 print:bg-white">
        <section className={SECTION}>
          <p className="text-xs tracking-[3px] text-[#C5A059] font-bold mb-3">INVESTIMENTO</p>
          <h2 className="text-3xl md:text-4xl font-black text-[#0A2647] mb-8 leading-tight">
            Planos por porte do negocio.
          </h2>

          <div className="grid md:grid-cols-3 gap-4">
            {[
              { name: 'Pro', price: 'R$ 39,90', limit: '30 avaliacoes/mes', wp: '2 WhatsApps', ideal: 'Pequeno comercio' },
              { name: 'Empresarial', price: 'R$ 59,90', limit: '60 avaliacoes/mes', wp: '3 WhatsApps', ideal: 'Negocio medio', best: true },
              { name: 'Elite', price: 'R$ 99,90', limit: '100 avaliacoes/mes', wp: '4 WhatsApps', ideal: 'Rede / franquia' },
            ].map((p) => (
              <div key={p.name} className={`rounded-2xl p-6 border-2 ${p.best ? 'border-[#C5A059] bg-amber-50/50 relative' : 'border-slate-200 bg-white'}`}>
                {p.best && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C5A059] text-[#0A2647] text-[10px] font-black px-3 py-1 rounded-full tracking-widest">MAIS VENDIDO</span>}
                <h3 className="text-xl font-black text-[#0A2647] mb-1">{p.name}</h3>
                <p className="text-2xl font-black text-[#C5A059] mb-3">{p.price}<span className="text-sm text-slate-500 font-normal">/mes</span></p>
                <ul className="text-sm text-slate-700 space-y-1.5">
                  <li>· {p.limit}</li>
                  <li>· {p.wp} para alertas</li>
                  <li>· Relatorios em Excel</li>
                  <li>· Suporte prioritario</li>
                </ul>
                <p className="text-xs text-slate-500 mt-3 italic">Ideal: {p.ideal}</p>
              </div>
            ))}
          </div>
          <p className="text-center text-sm text-slate-500 mt-6 italic">Sem fidelidade. Cancele quando quiser.</p>
        </section>
      </div>

      {/* CTA */}
      <div className="w-full bg-gradient-to-br from-[#0A2647] to-[#000814] text-white print:bg-white print:text-slate-900">
        <section className={`${SECTION} text-center`}>
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-[#C5A059]">
            Bora ouvir o seu cliente?
          </h2>
          <p className="text-lg text-white/80 print:text-slate-700 mb-8 leading-relaxed max-w-3xl mx-auto">
            Em menos de 24h, sua empresa esta implantada e recebendo as primeiras manifestacoes.
            Nossa equipe cuida de toda a configuracao.
          </p>
          <a
            href="https://www.falocomodono.com.br"
            className="inline-block bg-[#C5A059] text-[#0A2647] font-black text-base px-10 py-4 rounded-xl"
            data-testid="cta-falocomodono"
          >
            www.falocomodono.com.br
          </a>
          <p className="text-sm text-white/65 print:text-slate-600 mt-8">
            Falo com o Dono<span className="text-xs align-top">™</span> &middot; Voce fala, a gente faz acontecer.
          </p>
        </section>
      </div>

      <style>{`
        @media print {
          @page { margin: 1cm; size: A4; }
          body { font-size: 11pt; }
        }
      `}</style>
    </div>
  );
};

export default Apresentacao;
